import React, { useContext, useRef, useState } from "react";
import BottomNav from "../../components/Bottom nav/BottomNav";
import { useParams, useHistory } from "react-router-dom";
import useCommonQuery from "../../store/common/useCommonQuery";
import CategoreyCard from "../../components/CategoreyCard";
import BookmarkNotFound from "../myListing/bookmark/bookmarkNotFound/BookmarkNotFound";
import { Grid, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import ShareIcon from "@mui/icons-material/Share";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LayoutToggle from "../../components/LayoutToggle/LayoutToggle";
import { variableContext } from "../../context/VariableContex";
import "./ListView.css";
import "./DarkBlueListTheme.css";
import "../../page-header-controls.css";

function SubCategory() {
  const history = useHistory();
  const { id } = useParams();
  const inputRef = useRef();

  const [toggle, setToggle] = useState(false);
  const { layoutMode } = useContext(variableContext);

  const { data: subcategoryList, isSuccess } = useCommonQuery.Get_subcategory({
    id,
    search: "",
    limit: 2000,
    offset: 0,
  });

  const { data: categoryData } = useCommonQuery.Get_category({
    limit: 2000,
    offset: 0,
  });
  const categoryObj = categoryData?.data?.results?.find((c) => c.id === parseInt(id));
  const categoryName = categoryObj?.name || "Subcategories";
  const categoryCoverImage = categoryObj?.cover_image || null;

  const handleGridView = () => {
    setToggle(false);
  };
  const handleListView = () => {
    setToggle(true);
  };

  const handleClick = (name) => {
    history.push(`/category/${id}/subCategory/${name}`);
  };

  const handleShare = async () => {
    try {
      await navigator.share({
        url: window.location.href,
      });
    } catch (error) { }
  };




  return (
    <div
      id="parent-div"
      className={`subcat-root ${toggle ? "subcat-list" : "subcat-grid"}`}
      ref={inputRef}
      style={{ height: "100vh", overflowY: "scroll", backgroundColor: toggle ? "#02152D" : "#fff" }}
      data-grid-mode={layoutMode === "grid" ? "true" : undefined}
      data-category-id={id}
    >
      {/* ── Sticky header ── */}
      <div className="phc-bar">
        <div className="phc-inner" style={{ position: "relative" }}>

          {/* Page title above controls */}
          <div className="phc-title-row">
            <span className="phc-page-title">{categoryName}</span>
          </div>

          <div className="phc-row">

            {/* Back button */}
            <div className="phc-back" onClick={() => history.goBack()}>
              <ArrowBackIcon className="phc-back-icon" />
              <span className="phc-back-label">All Categories</span>
            </div>

            {/* Home button — directly beside All Categories */}
            <button className="phc-home-btn" onClick={() => history.push("/")}>
              <HomeIcon className="phc-home-btn-icon" />
              <span className="phc-home-btn-label">Home</span>
            </button>

            {/* Spacer */}
            <div className="phc-spacer" />

            {/* Layout toggle */}
            <LayoutToggle size="sm" />

            {/* Share */}
            <div className="phc-share-btn" onClick={handleShare}>
              <ShareIcon />
            </div>

          </div>

          {/* Cover image — only rendered when available */}
          {categoryCoverImage && (
            <div style={{ marginTop: "6px" }}>
              <img
                src={categoryCoverImage}
                alt={categoryName}
                style={{ width: "100%", height: "110px", objectFit: "cover", borderRadius: "6px", display: "block" }}
              />
            </div>
          )}
        </div>
      </div>


      {/* ── Grid layout ── */}
      <div
        style={{
          display: `${toggle ? "none" : "block"}`,
          marginBottom: "5rem",
        }}
      >
        {/* ── Dark-gray grid background ── */}
        <div className="scg-grid-bg">
          <Grid container spacing={2}>
            {subcategoryList &&
              subcategoryList?.data?.results?.map((items, idx) => (
                <CategoreyCard
                  id={items.id}
                  title={items.name}
                  handleClick={handleClick}
                  image={items.image}
                  cardBg="#ffffff"
                  key={idx}
                />
              ))}
          </Grid>
        </div>
      </div>

      {/* ── List layout ── */}
      <div
        className="scl-cards-panel"
        style={{ display: `${toggle ? "block" : "none"}`, marginBottom: "2rem" }}
      >
        <div className="clv-list-body" style={{ padding: "0 0.9rem" }}>
          {subcategoryList &&
            subcategoryList?.data?.results?.map((item, i) => (
              <div
                className="clv-list-card"
                onClick={() => history.push(`/category/${id}/subCategory/${item.id}`)}
                key={i}
              >
                <div className="clv-list-img-wrap">
                  <img
                    className="clv-list-img"
                    src={item.image}
                    alt={item.name}
                  />
                </div>
                <div className="clv-list-content">
                  <Typography className="clv-list-label">
                    {item.name}
                  </Typography>
                  <ChevronRightIcon className="clv-list-arrow" />
                </div>
              </div>
            ))}
        </div>
      </div>
      <BottomNav />
      {subcategoryList?.data?.results?.length === 0 ? (
        <BookmarkNotFound title="No SubCategories" />
      ) : null}
    </div>
  );
}

export default React.memo(SubCategory);

